var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"register"}},[_c('div',{staticClass:"reg-con"},[_vm._m(0),_c('authent-form',{attrs:{"from":'register',"details":_vm.reg,"btnText":'立即认证注册',"isConFlag":_vm.isConFlag}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('h3',[_vm._v("用户认证注册")])])
}]

export { render, staticRenderFns }